module.exports = __webpack_public_path__ + "img/malcom-x.366deadd.png";